import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DownloadFileService } from "src/app/services/download-file.service";
import { DocumentsRepositoryService } from "src/app/services/documents-repository.service";
import { DocumentsDetailsRawData,DocumentType } from "src/app/shared/models/documents.model";
import { AppConstants, FILE_BLOB_TYPE } from "src/app/app.constants";
import { SnackBarService } from "src/app/services/snack-bar.service";
import { PreviewDocumentComponent } from "../dialogs/preview-document/preview-document.component";


interface ToolTipParams extends ICellRendererParams {
  lineBreak?: boolean;
  toolTipArray?: string[];
  toolTip?: string;
};

@Component({
  selector: "app-tool-tip",
  templateUrl: "./tool-tip.component.html",
  styleUrls: ["./tool-tip.component.scss"],
})

export class ToolTipComponent implements ICellRendererAngularComp {  
  public params: ToolTipParams;
  public toolTip: string;
  private unsubscribe: Subject<void> = new Subject<void>();
  tooltipHoverData: string;
  subFolderName: string[]=[];
  docomentName: DocumentType[]=[];
  subFolder= '';
  documentsName= '';
  tooltipOptions: Object;
  readOnly:boolean=false;
  
  constructor(    
    private documentsService: DocumentsRepositoryService,
    private downloadFileService: DownloadFileService,
    private snackBarService: SnackBarService,
  ) {
    this.tooltipOptions= {
      'placement': 'top',
      'show-delay': '1',
      'hide-delay': '1',
      'tooltip-class': 'tooltip-feedback',
      'tooltipClass' : 'tooltip-feedback',
      'pointerEvents' : 'none'
    };
  }

  agInit(params: ToolTipParams): void {
    this.params = params;
    if (!this.params.data.docType){
      this.readOnly=this.params.data
      this.filterTooltipInvalidData();
      this.renderTooltip();
    }
  };

  renderTooltip() :void {
     if (this.subFolderName.length>0) {      
       this.subFolderName.forEach((folderName, index) => {
         index == (this.subFolderName.length - 1) ? this.subFolder +=`${folderName}` : this.subFolder += folderName+",   ";
       });
      this.docomentName.filter((item, index) => {
          index == (this.docomentName.length - 1) ? this.documentsName += `${item.documentTypeName}` : this.documentsName += item.documentTypeName+",   ";
       });
     } else if (this.docomentName.length>0) {      
      this.docomentName.forEach((item, index) => {       
        index == (this.docomentName.length - 1) ? this.documentsName += `${item.documentTypeName}` : this.documentsName += item.documentTypeName+",   ";
      });
     }
  };

  editClickHandler(rowData): void {
    this.params.context.FoldersViewComponent.editOpenDrawerHandler(rowData.id);    
  };

  downloadClickHandler(rowData): void {
    //const extensionType = rowData.name.split(".")[1];
    // const formTitle =  rowData.name.split(".")[0];
    const extension  = rowData.name.lastIndexOf('.');
    const formTitle = rowData.name.substring('.extension', extension);
    const extensionType = rowData.name.split(formTitle)[1];
    const ext1 = extensionType.split('.')[1];
    const downLoadInfo = {
      formName: formTitle,
      formNumber: rowData.id,
      extension: `.${ext1}`,
    };
    this.documentsService
      .getFileDownloadById(rowData.id)
      .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (solarFileDownloadData: Blob) => {
            this.downloadFileService.downloadSolarForm(
              solarFileDownloadData,
              downLoadInfo,
              false
            );
          },
          (err) => {
            this.snackBarService.showError(AppConstants.downloadDocMsgError)
          });
  };

  onPreviewIconClick(rowData) {
    const extensionType = rowData.name.split(".")[1];
    const previewInfo = {
      formName: rowData.name,
      formNumber: rowData.id,
      extension: `.${extensionType}`
    };
    this.documentsService
      .previewFileById(rowData.id)
      .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (solarFileDownloadData) => {
           // this.downloadFileService.previewSolarForm(solarFileDownloadData, previewInfo)
           var file = new Blob([solarFileDownloadData], {
            type: FILE_BLOB_TYPE.PDF,
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL, "_blank");
          },
          (err) => {
            this.snackBarService.showError(AppConstants.previewDocMsgError)
    });
  }

  refresh(params: ToolTipParams): boolean {
    this.params = params;
    return true;
  };

  filterTooltipInvalidData() : void {
    if(this.params.data.subFolders && this.params.data.subFolders.length>0){
      let validFilterSubFolders=this.params.data.subFolders.filter(item=>item.subFolderName!='');
      let validFilterDocumentType=this.params.data.subFolders.filter(item=>item.documentType && item.documentType.length>0);
      validFilterSubFolders.forEach(item => { this.subFolderName.push(item.subFolderName) });
      validFilterDocumentType.forEach(item => {     
        this.docomentName.push(...item.documentType) 
      });
    } else {
      if(this.params.data.documentType) {
        this.docomentName.push(...this.params.data.documentType);
      }
      
    }
  };
};

